// ============================================================
// Datei: src/pages/ForgotPassword.jsx
// ============================================================

import React, { useState } from "react";
import Api from "../Api";
import "../styles/forgotPassword.css"; // eigene Datei wie Login

const ForgotPassword = () => {

    const [email, setEmail] = useState("");
    const [message, setMessage] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const isValidEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email.trim());
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isValidEmail(email) || submitting) return;

        setSubmitting(true);
        setMessage(null);

        try {
            await Api.post("/auth/request-password-reset", { email });

            setMessage({
                type: "success",
                text: "Falls die E-Mail existiert, wurde ein Reset-Link gesendet."
            });

            setEmail("");

        } catch (error) {
            setMessage({
                type: "error",
                text: "Es gab ein Problem. Versuche es später erneut."
            });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            className="forgot-container bg-reveal"
            data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_forgotPassword.png`}
        >
            <div className="forgot-box">
                <h2 className="forgot-heading">Passwort vergessen</h2>

                {message && (
                    <div className={
                        message.type === "success"
                            ? "forgot-success"
                            : "forgot-error"
                    }>
                        {message.text}
                    </div>
                )}

                <form className="forgot-form" onSubmit={handleSubmit}>

                    <label className="forgot-label">E-Mail</label>
                    <input
                        type="email"
                        className="forgot-input"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="deine@email.com"
                        required
                    />

                    <button
                        className="forgot-button"
                        type="submit"
                        disabled={!isValidEmail(email) || submitting}
                    >
                        {submitting ? "Sende..." : "Reset-Link anfordern"}
                    </button>

                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
